import { takeLatest } from 'redux-saga/effects';
import * as t from '../../../../actionTypes';

import submit from './submit';

// eslint-disable-next-line func-names
export default function*() {
  yield takeLatest(t.RECAPTCHA_SUBMIT, ({ payload }) => submit(payload));
}
